<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/blog_review_top.jpg" />
    <img alt="Vue logo" src="../assets/blog_study_top.jpg" />
    <img alt="Vue logo" src="../assets/blog_top.jpg" />
    <img alt="Vue logo" src="../assets/code_display1950.jpg" />
    <img alt="Vue logo" src="../assets/logo.png" /> 
    <img alt="Vue logo" src="../assets/pentab_mouse.jpg" />
    <img alt="Vue logo" src="../assets/owner_arowe.jpg" />
    <img alt="Vue logo" src="../assets/top_logo.jpg" />
    <img alt="Vue logo" src="../assets/a-dot-r_logo.png" />
    <img alt="Vue logo" src="../assets/top_carousel_01.jpg" />
    <img alt="Vue logo" src="../assets/top_carousel_02.jpg" />
    <PortFolio msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import PortFolio from "@/components/PortFolio.vue";

export default {
  name: "Home",
  components: {
    PortFolio
  }
};
</script>
